import styled from '@emotion/styled';
import React from 'react';
import { Icon } from '../../../../shared/Icon';
import { clickedFooterLink } from '../../events';

const IconLink = styled.a`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 18px;
`;

type Platform = 'facebook' | 'twitter' | 'instagram';

type SocialLinkProps = {
  platformName: Platform;
};

function SocialLink({ platformName }: SocialLinkProps) {
  const { url = '', component = null, title = '' } = getPlatformInfo(
    platformName
  );
  return (
    <IconLink
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      onClick={() => clickedFooterLink(platformName)}
    >
      {component}
    </IconLink>
  );
}

type PlatformInfo = {
  url?: string;
  component?: JSX.Element;
  title?: string;
};

function getPlatformInfo(platformName: Platform): PlatformInfo {
  switch (platformName) {
    case 'twitter':
      return {
        url: 'https://twitter.com/anchor',
        component: <Icon type="TwitterLogo" fillColor="#C9CBCD" />,
        title: 'Twitter',
      };
    case 'facebook':
      return {
        url: 'https://www.facebook.com/anchor.fm/',
        component: <Icon type="FacebookLogo" fillColor="#C9CBCD" />,
        title: 'Facebook',
      };
    case 'instagram':
      return {
        url: 'https://www.instagram.com/anchor.fm/',
        component: <Icon type="Instagram" fillColor="#C9CBCD" />,
        title: 'Instagram',
      };
    default:
      return {};
  }
}

export { SocialLink };
